import React from "react";
import Logo from "../Logo";
import "./styles.css";

const PageBottomContent = (props) => {
  const { text = "", logo = false } = props;

  return (
    <div className="footer-row page-bottom">
      {logo && (
        <div className="footer-logo">
          <Logo />
        </div>
      )}
      <div className="page-bottom__txt">{text}</div>
    </div>
  );
};

export default PageBottomContent;
